export default __webpack_public_path__ + "static/media/kitchen.47282703.mp4";